import { createI18n } from 'vue-i18n'
import cs from './locales/cs.json'
import en from './locales/en.json'

export type AppLocale = 'cs' | 'en'

export function createAppI18n(locale: AppLocale = 'cs') {
    return createI18n({ legacy: false, locale, fallbackLocale: 'cs', messages: { cs, en } })
}
